import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTruck, faCar, faPaperPlane, faCalendarAlt, faIdCard } from '@fortawesome/free-solid-svg-icons'
export default class Results extends React.Component {
    constructor(props){
        super(props);
        // console.table(props);
        this.state = {
            jurisdictionIssueId: this.props.status.jurisdictionIssueId,
            documentType : this.props.status.documentKind,
            issueDate: this.props.status.issueDate,
            mailDate: this.props.status.mailDate,
            mailTracking: this.props.status.mailTrackingInfo,
        };
    }
    
    render(){
        // Extract just the DLN (first part before underscore) from jurisdictionIssueId
        const dln = this.state.jurisdictionIssueId ? this.state.jurisdictionIssueId.split('_')[0] : this.state.jurisdictionIssueId;

        const statusInfo = [
            {
                title:'Driver License Number:',
                data:dln,
                icon:faIdCard,
                iconBackground:'text-pink-500',
                ring: 'ring-pink-500'
            },
            {
                title: 'Document Type:',
                data:this.state.documentType,
                icon:this.state.documentType === 'CDL' ? faTruck : this.state.documentType === 'ID' ? faIdCard : faCar,
                iconBackground: 'text-blue-500',
                ring: 'ring-blue-500'
            },
            {
                title:'Issue Date:',
                data:this.state.issueDate,
                icon:faCalendarAlt,
                iconBackground:'text-green-500',
                ring: 'ring-green-500'
            },
            {
                title:'Mailing Date:',
                data:this.state.mailDate,
                message:"Please allow 10 days from mailing date to receive document.",
                icon:faPaperPlane,
                iconBackground:'text-indigo-500',
                ring: 'ring-indigo-500'
            },
            
        ];

        return (
        <div className="mb-10 bg-white dark:bg-gray-600 justify-items-center items-center md:w-3/4 md:mx-auto ">
            <div className="sm:h-1/2 bg-gray-200 overflow-hidden shadow divide-y divide-gray-200 sm:divide-y-0 sm:grid sm:grid-cols-2 sm:gap-px">
                    {statusInfo.map((status, id) => (
                        <div key={status.id} className="relative group bg-white p-6 dark:bg-gray-800">
                            <div>
                                <span className={`rounded-lg inline-flex p-3 ring-4 dark:ring-white status ${status.ring}`}>
                                    <FontAwesomeIcon icon={status.icon} className={`self-center font-extrabold ${status.iconBackground} dark:text-white`} aria-hidden="true" />
                                </span>
                            </div>
                            <div className="mt-8">
                                <h3 className="text-lg font-medium font-extrabold text-black dark:text-white">
                                    {status.title} 
                                </h3>
                                <p className="mt-2 text-lg text-black font-bold dark:text-white">
                                    {status.data}
                                    <br/>
                                    {status.message}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        ) 
    }
}